import { Link } from 'react-router-dom'
import React, { useMemo, useRef } from 'react'
import { useThumbnailURL } from '../../../../../../shared/thumbnail-cache/use-thumbnail'
import './grid-item.scss'

// A node's card in a grid: its thumbnail (the link to it) and a footer row
// of its kind's icon, its name with its `Badges` (a course's platforms) and
// its `Detail` (a course's "Updated 5 minutes ago") under it, and its
// `FooterMenu` (pinned buttons and ⋮). The name truncates first; nothing
// else in the row shrinks. The badges sit under the name so a narrow card
// still shows most of it. The card is a cell of a `node-grid` (grid-item.scss).
export const GridNode = ({ Icon, FooterMenu, Badges, Detail, Overlay, node, to, dataContext }) => {
  return (
    <div className="node-grid-cell">
      <div className="card">
        <div className="card-body p-1">
          <div className="d-flex flex-column">
            <div className="flex-fill" style={{ position: 'relative' }}>
              <Link to={to}>
                {Overlay && <Overlay />}
                <ThumbnailImage nodeID={node.id} dataContext={dataContext} />
              </Link>
            </div>
            <div className="d-flex border-top m-1 align-items-center">
              <div className="m-1 flex-shrink-0">
                {Icon && <Icon size="lg" />}
              </div>
              <div className="flex-fill m-1" style={{ minWidth: 0 }}>
                <div className="text-truncate fs-6" title={node.name}>
                  {node.name}
                </div>
                {Badges && <Badges />}
                {Detail && <Detail />}
              </div>
              <div className="m-1 flex-shrink-0">
                {FooterMenu && <FooterMenu />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

// The card's picture: the node's thumbnail once there is one to show (see
// shared/thumbnail-cache/use-thumbnail.js: this page's memory, the browser's
// storage, then the network once the card nears the viewport), the
// placeholder until then. Decorative: the card's name is right under it.
const ThumbnailImage = ({ nodeID, dataContext }) => {
  const ref = useRef(null)
  const thumbnail = useMemo(() => dataContext.thumbnails.find(asset => asset.nodeID === nodeID), [nodeID, dataContext])
  const url = useThumbnailURL(thumbnail, ref)

  return <img ref={ref} className="course-image" src={url || '/content_placeholder.png'} alt="" data-testid="node-thumbnail" />
}
